import React from 'react';
import { useChannelDescription } from '../../../Slice';
import PropTypes from 'prop-types';

function ChannelDescription(props) {
   const { channelId, status } = props;
   const desc = useChannelDescription(channelId) || '';
   const showTooltip = status === 'recentChannel' && desc.length > 0;

   return (
      <p
         className="channel_description_text"
         title={showTooltip ? desc : undefined}
         aria-label={showTooltip ? 'Channel description' : undefined}
      >
         {desc || ''}
      </p>
   );
}
export default ChannelDescription;

ChannelDescription.propTypes = {
   channelId: PropTypes.string,
};
